<template>
  <div>
    <month-range-picker
      class="px-3"
      style="flex-grow: 1"
      header="Claims Date Range"
      :footer="'Last Update: ' + browserDateTime(lastRunTime)"
      :min="min"
      :max="max"
      :value="value"
      @input="$emit('input', $event)"
      helpText="Restricts the set of claims analyzed to identify HCPs and Patients"
      @reset-from="$emit('input', { ...value, from: min })"
      @reset-to="$emit('input', { ...value, to: max })"
      v-if="!isLoading"
    >
      <template #menu>
        <div class="hvh-upper-right">
          <v-menu :close-on-content-click="true" bottom left origin="top right" style="z-index: 1001">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="my-1 mx-2" flat icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-card class="py-0 mr-2">
              <v-list class="py-0">
                <v-list-tile>
                  <v-list-tile-sub-title>Select specific date</v-list-tile-sub-title>
                </v-list-tile>
              </v-list>
              <v-list class="py-0">
                <v-list-tile>
                  <v-btn class="mx-0" flat small @click="pickLastMonths(12)">12M</v-btn>
                  <v-btn class="mx-0" flat small @click="pickLastMonths(24)">24M</v-btn>
                  <v-btn class="mx-0" flat small @click="pickLastYear">Last Year</v-btn>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </template>
    </month-range-picker>
    <div v-else>
      <h2 class="pb-1" style="white-space: pre">&nbsp;</h2>
      <dd><v-progress-linear class="my-2" height="6" :indeterminate="true"></v-progress-linear></dd>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  noExport: true,
  props: ['value', 'min', 'max', 'lastRunTime', 'isLoading'],
  methods: {
    pickLastMonths(months) {
      var to = moment.utc(this.max).endOf('month');
      var from = [to.clone().add(-months, 'M').add(1, 'ms'), this.min].max();
      this.$emit('input', { from: from.toISOString(), to: to.toISOString() });
    },
    pickLastYear() {
      var to = moment.utc(this.max).startOf('year').add(-1, 'ms');
      var from = [to.clone().startOf('year'), this.min].max();
      this.$emit('input', { from: from.toISOString(), to: to.toISOString() });
    },
  },
}
</script>